import { render, staticRenderFns } from "./Messager.vue?vue&type=template&id=7df5d892&"
import script from "./Messager.vue?vue&type=script&lang=js&"
export * from "./Messager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports